import "tippy.js/dist/tippy.css"; // optional for styling

import Tabby from "tabbyjs";
import tippy from "tippy.js";

if (document.querySelector("[data-tabs]")) {
	var tabs = new Tabby("[data-tabs]");
}

tippy("[data-tippy-content]", {
	hideOnClick: false,
});

Array.from(document.querySelectorAll(".tabbed-content .js-tabby-toggle")).map(
	(toggle) => {
		toggle.addEventListener("click", function (e) {
			const container = toggle
				.closest("[data-tabs]")
				.closest("div")
				.closest("section");

			if (container) {
				const checkbox = container.querySelector('input[type="checkbox"]');
				if (checkbox) {
					checkbox.checked = false;
				}
			}
		});
	}
);

document.querySelectorAll(".tabbed-content__admin-copy").forEach((button) => {
	button.addEventListener("click", (event) => {
		// Find the button's parent container
		const container = event.target.parentElement;
		const tippyInstance = button._tippy; // Get the Tippy.js instance for this button

		if (container) {
			const baseUrl = window.location.origin + window.location.pathname;

			navigator.clipboard
				.writeText(`${baseUrl}#${container.id}`)
				.then(() => {
					tippyInstance.setContent("Copied!");
					setTimeout(() => {
						tippyInstance.setContent("Don't worry - only Admins can see this!");
					}, 2500);
				})
				.catch((err) => {
					console.error("Failed to copy text:", err);
				});
		}
	});
});
